// 메서드·요청 URL·부가 정보를 한 덩어리로 보여주는 컴포넌트
import { useState } from 'react';
import classes from './DescriptionPageTemplate.module.css';

/**
 * 엔드포인트 카드.
 * 기존에 HTTP Method 와 Request URL 두 섹션으로 흩어져 있던 정보를 한곳에 모은다.
 *
 * id 는 두 개를 유지한다. SearchModal 이 검색 결과에서 `#request-url` 과 `#http-method` 로
 * 링크하고 있어, 앵커를 없애면 그 링크가 깨진다.
 *
 * 메서드 배지와 URL 경로의 스타일은 카드 전용 클래스로 둔다. 기존 `.section .POST` 계열은
 * `.section` 자손으로 스코프되어 카드에서는 먹지 않고, API TEST 영역이 그 규칙을 쓰고 있어
 * 스코프를 풀면 그쪽이 함께 바뀐다.
 */
const EndpointCard = ({ method, url, baseUrl, headers }) => {
  const [copied, setCopied] = useState(false);
  const fullUrl = `${baseUrl}/api${url}`;

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(fullUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 1200);
    } catch {
      // clipboard 는 HTTPS·localhost 에서만 동작한다. 실패를 조용히 넘기지 않고 알린다
      window.prompt('아래 주소를 복사하세요', fullUrl);
    }
  }

  const authHeaders = (headers || []).map((row) => row.title).filter(Boolean);

  return (
    <div className={classes.endpoint} id="request-url">
      <div className={classes.endpointMain}>
        {/* 메서드별 색은 data-method 로 분기한다. .section .POST 계열은 카드에 적용되지 않는다 */}
        <span className={classes.endpointVerb} data-method={method} id="http-method">
          {method}
        </span>
        <span className={classes.endpointUrl}>
          <span className={classes.endpointBase}>{baseUrl}/api</span>
          <b className={classes.endpointPath}>{url}</b>
        </span>
        <button type="button" className={classes.endpointCopy} onClick={handleCopy}>
          {copied ? '복사됨' : 'URL 복사'}
        </button>
      </div>

      <div className={classes.endpointMeta}>
        {/* 기존 코드와 같은 조건. POST 일 때만 Content-Type 을 표시한다 */}
        {method === 'POST' && (
          <span>
            Content-Type : <code>application/json; charset=UTF-8</code>
          </span>
        )}
        {authHeaders.length > 0 && (
          <span>
            인증{' : '}
            {authHeaders.map((name, i) => (
              <span key={name}>
                {i > 0 && ' + '}
                <code>{name}</code>
              </span>
            ))}
          </span>
        )}
      </div>
    </div>
  );
};

export default EndpointCard;
